/**
 * @file automatically generated from MApp.Endpoints.LocalizationController
 */

import { MetadataClient } from '../metadata-client';
import { IBrowserLocalization, IAvailableLocalization } from '../models';

export class LocalizationClient extends MetadataClient {

	public static getAppLauncherLocalization(language: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/applauncher/localization?language=${encodeURIComponent(language)}`, {
				cache: 'no-cache',
				...requestInit
			}),
			true
		);
	}

	public static getDesktopClientLocalization(requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/desktopclient/localization`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getBrowserLocalization(languageCode: string, timestamp: number, requestInit?: RequestInit) {
		return MetadataClient.ajax<IBrowserLocalization>(
			new Request(MetadataClient.endpointsUrl + `api/v4/browser/localization/${encodeURIComponent(languageCode)}?timestamp=${encodeURIComponent(timestamp)}`, {
				cache: 'no-cache',
				...requestInit
			}),
			true
		);
	}

	public static getStudioLocalization(requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getSolutionLocalization(solution: string, component: string, name: string, format: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/localization/${encodeURIComponent(solution)}/${encodeURIComponent(component)}/${encodeURIComponent(name)}?format=${encodeURIComponent(format)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getDefaultLocalization(requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization/detect`, {
				cache: 'no-cache',
				...requestInit
			}),
			true
		);
	}

	public static getLocalizations(requestInit?: RequestInit) {
		return MetadataClient.ajax<IAvailableLocalization[]>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localizations`, {
				cache: 'no-cache',
				...requestInit
			}),
			true
		);
	}

	public static getAllLocalizations(requestInit?: RequestInit) {
		return MetadataClient.ajax<IAvailableLocalization[]>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localizations/all`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getCldrLocalization(requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization/cldr`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getDefaultCldrLocalization(requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v3/studio/localization/cldr/detect`, {
				cache: 'no-cache',
				...requestInit
			}),
			true
		);
	}

	public static getAvailableLocalizations(requestInit?: RequestInit) {
		return MetadataClient.ajax<IAvailableLocalization[]>(
			new Request(MetadataClient.endpointsUrl + `api/v3/localization/available`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}
}
